<voxel-loading-circle *ngIf="isLoading" class="loading" [loadingTitle]="CONTENT_BOUNDS?.load_text"></voxel-loading-circle>
<ng-container *ngIf="!isLoading">
    <div class="card" *ngIf="CONTENT_BOUNDS?.sections?.verify_client; let section">
        <div class="card-content">
            <div class="voxel-col-12" *ngIf="customerError?.value">
                <voxel-alert [type]="CONTENT_BOUNDS?.error_notification?.type" light class="voxel-mb-2"
                    [icon]="CONTENT_BOUNDS?.error_notification?.icon">
                    {{this.CONTENT_BOUNDS?.error_notification?.text}}
                </voxel-alert>
            </div>
            <p>{{section?.title}}</p>
            <form [formGroup]="form" autocomplete="off">
                <div class="voxel-row">
                    <voxel-form-field
                        *ngIf="CONTENT_BOUNDS?.sections?.verify_client?.controls?.document_type; let control;"
                        class="voxel-col-xs-4 voxel-col-sm-4 voxel-col-md-6 " [label]="control?.label"
                        [msgErr]="(getMessageError({label: control?.label, formControlName: (control?.formControlName)}, form.get((control?.formControlName))?.errors) | async) || control?.msgErr">
                        <voxel-select [formControlName]="(control?.formControlName)">
                            <voxel-option *ngFor="let option of documentTypeList" [value]="option?.id"
                                [disabled]="false">
                                {{ option?.name | unicode}}
                            </voxel-option>
                        </voxel-select>
                    </voxel-form-field>

                    <voxel-form-field
                        *ngIf="CONTENT_BOUNDS?.sections?.verify_client?.controls?.document_number; let control;"
                        class="voxel-col-xs-4 voxel-col-sm-4 voxel-col-md-6" [label]="control?.label"
                        [msgErr]="(getMessageError({label: control?.label, formControlName:(control?.formControlName)}, form.get((control?.formControlName))?.errors) | async) || control?.msgErr">
                        <input voxelInput [placeholder]="control?.description"
                            [formControlName]="(control?.formControlName)" />
                    </voxel-form-field>
                </div>
                <app-terms-conditions-modal #modalTermsConditions [formGroup]="form"
                    [componentStart]="true"></app-terms-conditions-modal>
            </form>
        </div>
    </div>
</ng-container>